__turbopack_context__.v({
  "card": "AuthContainer-module__4EapQG__card",
  "content": "AuthContainer-module__4EapQG__content",
  "footer": "AuthContainer-module__4EapQG__footer",
  "glow": "AuthContainer-module__4EapQG__glow",
  "heading": "AuthContainer-module__4EapQG__heading",
  "headingWrap": "AuthContainer-module__4EapQG__headingWrap",
  "legalFooter": "AuthContainer-module__4EapQG__legalFooter",
  "loader": "AuthContainer-module__4EapQG__loader",
  "logo": "AuthContainer-module__4EapQG__logo",
  "logoWrap": "AuthContainer-module__4EapQG__logoWrap",
  "shell": "AuthContainer-module__4EapQG__shell",
});
